module.exports = {
  path: 'replace',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationDeviceSlavesReplace'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/configuration/routes/devices/routes/show/routes/slaves/routes/show/routes/replace/index.js